import { useEffect, useState } from 'react';
import axios from '../utils/axios';

export function useMarketRegulatoryCardStatuses() {
    const [statuses, setStatuses] = useState<Record<number, boolean | null> | null>(null);
    useEffect(() => {
        const controller = new AbortController();
        axios.get('/market/regulatory-card-status', { signal: controller.signal, timeout: 30000 })
            .then(({ data }) => {
                if (controller.signal.aborted) return;
                const next: Record<number, boolean | null> = {};
                if (Array.isArray(data)) {
                    for (const item of data) {
                        if (Number.isSafeInteger(item?.marketId) && item.marketId > 0) {
                            next[item.marketId] = typeof item.enabled === 'boolean' ? item.enabled : null;
                        }
                    }
                }
                setStatuses(next);
            }).catch(() => { if (!controller.signal.aborted) setStatuses({}); });
        return () => controller.abort();
    }, []);
    return statuses;
}
